import React from "react";
import { ListGroup, ListItem } from "../elements/bodyComponents";

/*
    Header Overlay
*/
export class ImageOverlay extends React.Component {
  /*constructor( props ){

    }*/
  render() {
    return (
      <div className={`image-overlay ${this.props.classes}`}>
        {this.props.children}
      </div>
    );
  }
}

/*
    Benefits Group
*/
export class Benefits extends React.Component {
  render() {
    return (
      <ListGroup classes={`benefits flex ${this.props.classes}`}>
        <ListItem classes="dash-below dash-center dash-large dash-yellow uppercase">
          No Artificial Flavors
        </ListItem>
        <ListItem classes="dash-below dash-center dash-large dash-purple uppercase">
          No Artificial Colors
        </ListItem>
        <ListItem classes="dash-below dash-center dash-large dash-red uppercase">
          No High Fructose Corn Syrup
        </ListItem>
      </ListGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/headerComponents.js